/**
 * 이미지 accept 관련 유틸리티 함수
 */

/**
 * 이미지 확장자 accept 문자열을 정규화된 MIME 타입으로 변환
 *
 * @param accept - 허용할 이미지 확장자 문자열
 * @returns 정규화된 MIME 타입 문자열
 *
 * @example
 * ```typescript
 * normalizeImageAccept('png, jpg') // 'image/png,image/jpg'
 * normalizeImageAccept('.png,.jpg') // 'image/png,image/jpg'
 * normalizeImageAccept('PNG, JPG') // 'image/png,image/jpg'
 * normalizeImageAccept('png,image/jpg') // 'image/png,image/jpg'
 * normalizeImageAccept('*') // 'image/*'
 * normalizeImageAccept('png,invalid,jpg') // 'image/png,image/jpg'
 * ```
 */
export const normalizeImageAccept = (accept: string): string => {
  const ACCEPT_ALL_MIME_TYPE = 'image/*';
  const SUPPORTED_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp'] as const;

  if (!accept || typeof accept !== 'string' || accept.includes('*')) {
    return ACCEPT_ALL_MIME_TYPE;
  }

  const validMimeTypes = accept
    .trim()
    .toLowerCase()
    .replace(/\.|image\//g, '')
    .split(',')
    .reduce((acc, item) => {
      if (item && SUPPORTED_IMAGE_EXTENSIONS.includes(item as (typeof SUPPORTED_IMAGE_EXTENSIONS)[number])) {
        acc.push(`image/${item}`);
      }
      return acc;
    }, [] as string[])
    .join(',');

  return validMimeTypes || ACCEPT_ALL_MIME_TYPE;
};
